
import React, { useEffect, useState } from 'react';
import { listarContasReceber, receberConta } from '../../services/financeiroService';

const initialForm = {
  cliente_id: '',
  descricao: '',
  valor_total: '',
  data_vencimento: '',
};


export default function ContasReceberPage() {
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);


  useEffect(() => {
    listarContasReceber().then(res => {
      setContas(res.data.data);
      setLoading(false);
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      // Adapte para o endpoint correto de criação se existir
      const res = await fetch('/api/contas-receber', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        const data = await res.json();
        setContas((prev) => [...prev, { ...form, id: data.id, status: 'pendente' }]);
        setForm(initialForm);
      } else {
        alert('Erro ao salvar conta.');
      }
    } finally {
      setSaving(false);
    }
  };

  const handleReceber = async (id) => {
    await receberConta(id, { data_recebimento: new Date().toISOString().slice(0, 10) });
    setContas(contas.map(c => c.id === id ? { ...c, status: 'recebido' } : c));
  };


  if (loading) return <div>Carregando...</div>;

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <h2 style={{ marginBottom: 24 }}>Contas a Receber</h2>

      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 12, marginBottom: 32, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Cliente (ID)</label>
          <input name="cliente_id" value={form.cliente_id} onChange={handleInputChange} required style={{ padding: 6, minWidth: 80 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Descrição</label>
          <input name="descricao" value={form.descricao} onChange={handleInputChange} required style={{ padding: 6, minWidth: 120 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Valor</label>
          <input name="valor_total" type="number" step="0.01" value={form.valor_total} onChange={handleInputChange} required style={{ padding: 6, minWidth: 80 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Vencimento</label>
          <input name="data_vencimento" type="date" value={form.data_vencimento} onChange={handleInputChange} required style={{ padding: 6, minWidth: 120 }} />
        </div>
        <button type="submit" disabled={saving} style={{ padding: '8px 18px', background: '#4b2e1e', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
          {saving ? 'Salvando...' : 'Adicionar'}
        </button>
      </form>

      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0001' }}>
        <thead style={{ background: '#f5f5f5' }}>
          <tr>
            <th style={{ padding: 10, textAlign: 'left' }}>Cliente</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Descrição</th>
            <th style={{ padding: 10, textAlign: 'right' }}>Valor</th>
            <th style={{ padding: 10, textAlign: 'center' }}>Vencimento</th>
            <th style={{ padding: 10, textAlign: 'center' }}>Status</th>
            <th style={{ padding: 10, textAlign: 'center' }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {contas.length === 0 && (
            <tr>
              <td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#888' }}>Nenhuma conta cadastrada.</td>
            </tr>
          )}
          {contas.map(conta => (
            <tr key={conta.id} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: 8 }}>{conta.nome_completo || conta.cliente_id}</td>
              <td style={{ padding: 8 }}>{conta.descricao}</td>
              <td style={{ padding: 8, textAlign: 'right' }}>{Number(conta.valor_total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
              <td style={{ padding: 8, textAlign: 'center' }}>{conta.data_vencimento}</td>
              <td style={{ padding: 8, textAlign: 'center' }}>{conta.status}</td>
              <td style={{ padding: 8, textAlign: 'center' }}>
                {conta.status === 'pendente' && (
                  <button onClick={() => handleReceber(conta.id)} style={{ padding: '4px 12px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Receber</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
